import { InterwillDto } from '@/entities/interwills';

import { CollectionName } from '../../constants';
import { FileMetaInfoDto } from '../../models/file-meta-info.dto';
import { CurrentMigrationCollectionItem, MigrationType } from '../types';

const migrateInterwillFiles = (
  item: CurrentMigrationCollectionItem,
  filePathsToMigrate: Set<string>,
): FileMetaInfoDto => {
  const file = item as unknown as FileMetaInfoDto;
  const isFileAttached = filePathsToMigrate.has(file.filePath);

  return isFileAttached ? { ...file, isFileAttached: true } : file;
};

const migrate: MigrationType['migrate'] = (data) => {
  const interwills = data.get(CollectionName.INTERWILLS);
  const fileMetaInfos = data.get(CollectionName.FILE_META_INFO);

  if (!interwills?.size || !fileMetaInfos?.size) return data;

  const filePathsToMigrate = new Set<string>();

  interwills.forEach((item) => {
    const iwItem = item as Partial<InterwillDto>;

    if (iwItem.executionState?.finalPdfUrl) {
      filePathsToMigrate.add(iwItem.executionState.finalPdfUrl);
    }

    if (iwItem.executionState?.signedWill) {
      filePathsToMigrate.add(iwItem.executionState.signedWill.url);
    }

    if (iwItem.executionState?.supportedDocuments.length) {
      iwItem.executionState?.supportedDocuments.forEach((doc) => filePathsToMigrate.add(doc.url));
    }

    if (iwItem.executionState?.testatorVerification?.filePath) {
      filePathsToMigrate.add(iwItem.executionState?.testatorVerification?.filePath);
    }

    if (iwItem.executionState?.witnessVerifications) {
      Object.values(iwItem.executionState?.witnessVerifications).forEach((file) =>
        filePathsToMigrate.add(file.filePath),
      );
    }

    if (iwItem.executionState?.videoCertificates) {
      Object.values(iwItem.executionState?.videoCertificates).forEach((file) =>
        filePathsToMigrate.add(file.filePath),
      );
    }

    if (iwItem.executionState?.willCertificatePath) {
      filePathsToMigrate.add(iwItem.executionState?.willCertificatePath);
    }

    if (iwItem.editingState?.pdfDrafts) {
      Object.values(iwItem.editingState?.pdfDrafts).forEach((file) => filePathsToMigrate.add(file));
    }
  });

  const updatedFileMeta = new Map();
  fileMetaInfos.forEach((item, id) => {
    updatedFileMeta.set(id, migrateInterwillFiles(item, filePathsToMigrate));
  });

  const result = new Map(data);
  result.set(CollectionName.FILE_META_INFO, updatedFileMeta);

  return result;
};

export const migration16: MigrationType = {
  migrate,
  version: 17,
};
